import { render, staticRenderFns } from "./index.vue?vue&type=template&id=487ebd8f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ebd8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487ebd8f')) {
      api.createRecord('487ebd8f', component.options)
    } else {
      api.reload('487ebd8f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=487ebd8f&scoped=true&", function () {
      api.rerender('487ebd8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/directStatic/index.vue"
export default component.exports